
import {Date_Util} from './filter.date';
import {Item_Size} from "../utils/classes/item/Size";
import {Util_Filter_Folder} from "./filter.folder";

let MixinHelper = {
  lastNotifyError: ''
};

export const MixinVariables = {
  // data() {
  //   return  mixinData;
  // },
  computed: {
    // isLoggedIn() {
    //   return  Session.isLoggedIn();
    // }
  },
  methods: {
    $notifySuccess(msg, title = '成功') {
      this.$vs.notify({
        title: title,
        text: msg,
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success'
      });
    },
    $notifyError(msg, title = '错误') {
      if ('请登录' == msg && msg == MixinHelper.lastNotifyError) { // 防止连续多次提示"请登录"
        MixinHelper.lastNotifyError = '';
        return;
      }
      MixinHelper.lastNotifyError = msg;
      this.$vs.notify({
        title: title,
        text: msg,
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    },
    $notifyInfo(msg, title = '信息') {
      this.$vs.notify({
        title: title,
        text: msg,
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-message-square',
        color: 'primary'
      });
    },
    focusEl(el_id) {
      let element = this.$el.querySelector('#' + el_id);
      if (element && element.focus) { element.focus(); }
    }
    // goToLogin() {
    //   Navigator.redirect('/login');
    // },
    // getStaticUrl(uri) {
    //   return  process.env.VUE_APP_STATIC_IMAGE_PREFIX + uri;
    // }
  },
  // filters: MixinFilters
  filters: {
    Folder_Meta: (entry) => { return Util_Filter_Folder.meta(entry); },
    FileSize_humanRead: (int) => { return Item_Size.intToHuman(int).human; },
    humanRead: (ts, acc = false) => { return Date_Util.humanRead(ts); },
    Date_humanRead: (ts, acc = false) => { return Date_Util.smartHumanRead(ts, acc); }
  }
};


